import { createSlice } from '@reduxjs/toolkit';
import { createReducerNames } from '../../../core/helpers/default';

const name = 'labels';

const reducersKeys = {
  getLabelsRequest: 'getLabelsRequest',
  getLabelsSuccess: 'getLabelsSuccess',
  getLabelsFailure: 'getLabelsFailure',
  deleteLabelRequest: 'deleteLabelRequest',
  deleteLabelSuccess: 'deleteLabelSuccess',
  deleteLabelFailure: 'deleteLabelFailure',
};

const initialState = {
  data: [],
  meta: {},
  loaded: false,
  loading: false,
  error: null,
};

const labelsList = createSlice({
  name,
  initialState,
  reducers: {
    [reducersKeys.getLabelsRequest]: (state) => {
      state.loading = true;
      state.loaded = false;
      state.payout = null;
    },
    [reducersKeys.getLabelsSuccess]: (state, { payload }) => {
      state.data = payload.labels;
      state.meta = payload.meta;
      state.loading = false;
      state.loaded = true;
    },
    [reducersKeys.getLabelsFailure]: (state, { payload }) => {
      state.loading = false;
      state.loaded = true;
      state.error = payload.error;
    },
    [reducersKeys.deleteLabelRequest]: (state) => {
      state.loading = true;
      state.payout = null;
    },
    [reducersKeys.deleteLabelSuccess]: (state, { payload }) => {
      state.data = state.data.filter((i) => (i.id !== payload.deletedId));
      state.loading = false;
    },
    [reducersKeys.deleteLabelFailure]: (state, { payload }) => {
      state.loading = false;
      state.error = payload.error;
    },
  },
});

export const labelsListReducers = createReducerNames(name, reducersKeys);
export const { actions } = labelsList;

export default labelsList.reducer;
